import addNote from './add-note';
import addTaxIdentifiers from './add-tax-identifiers';
import adjustWeight from './adjust-weight';
import applyShippingPreset from './apply-shipping-preset';
import confirmation from './confirmation';
import customFieldOne from './custom-fields/one';
import customFieldTwo from './custom-fields/two';
import customFieldThree from './custom-fields/three';
import customsDeclarations from './customs-declarations';
import dimensions from './dimensions';
import dutiesAndTaxes from './duties-and-taxes';
import emailTemplate from './email-template';
import insurance from './insurance';
import otherShippingOptions from './other-shipping-options';
import packagebulkaction from './package';
import packingSlipTemplate from './packing-slip-template';
import shipbydate from './ship-by-date';
import shipfrom from './ship-from';
import shippingAccount from './shipping-account';
import shippingService from './shipping-service';
import weight from './weight';

export default [
  addNote,
  addTaxIdentifiers,
  confirmation,
  customFieldOne,
  customFieldTwo,
  customFieldThree,
  dimensions,
  dutiesAndTaxes,
  packagebulkaction,
  shipbydate,
  insurance,
  shipfrom,
  weight,
  packingSlipTemplate,
  emailTemplate,
  shippingService,
  otherShippingOptions,
  applyShippingPreset,
  customsDeclarations,
  adjustWeight,
  shippingAccount,
];
